/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowaskdescription3Inputs */

const en_aiflowaskdescription3 = /** @type {(inputs: Aiflowaskdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here is the description. Change whatever doesn't fit right in the field.`)
};

const de_aiflowaskdescription3 = /** @type {(inputs: Aiflowaskdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier ist die Beschreibung. Ändere direkt im Feld, was nicht passt.`)
};

/**
* | output |
* | --- |
* | "Here is the description. Change whatever doesn't fit right in the field." |
*
* @param {Aiflowaskdescription3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskdescription3 = /** @type {((inputs?: Aiflowaskdescription3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskdescription3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskdescription3(inputs)
	return de_aiflowaskdescription3(inputs)
});
export { aiflowaskdescription3 as "aiFlowAskDescription" }